import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, throwError, catchError } from 'rxjs';

import { ConfigService, SentryLogger } from '@fcom/core/services';

import { NewsletterSignupPayload, NewsletterSignupResponse } from '../../interfaces/newsletter-signup.interface';

@Injectable()
export class NewsletterSignupService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);
  private sentryLogger = inject(SentryLogger);

  postSubscribeRequest(payload: NewsletterSignupPayload): Observable<NewsletterSignupResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .post<NewsletterSignupResponse>(
        `${this.configService.cfg.customerCommunicationsApiUrl}/newsletter`,
        payload,
        httpOptions
      )
      .pipe(
        catchError((err: unknown) => {
          this.sentryLogger.warn('Failed to post newsletter subscription call', { error: err });
          return throwError(() => err);
        })
      );
  }
}
